const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/MedicationCard/MedicationCard.tsx';
import { useIntl } from 'react-intl';
import { Typography } from '@mui/material';
import textMap from './translations';
import * as React from 'react';
import { useMedicationData } from 'App/store/medication';
import { useHistory } from 'react-router';
import { goToMedis } from 'App/utils/history';
import { DashboardCard } from '../DashboardCard';
import { CardNavigationLink } from '../CardNavigationLink';

interface Props {}

export const MedicationCard = (props: Props) => {
    const { formatMessage } = useIntl();
    const history = useHistory();

    const [medis, isLoadingMedis] = useMedicationData();
    const numMedis = medis?.length || 0;
    const hasData = !!medis?.length;

    const handleClick = () => goToMedis(history);

    return (
        <DashboardCard
            iconClass="icons8-pill-filled"
            onClick={handleClick}
            isDataLoading={isLoadingMedis}
            hasData={hasData}
        >
            <CardNavigationLink text={textMap.cardTitle} />
            {numMedis ? (
                <Typography variant="body1">{formatMessage(textMap.medicationText, { count: numMedis })}</Typography>
            ) : null}
        </DashboardCard>
    );
};
